import React from "react";
import styled from "styled-components";
import { Link as ScrollLink } from "react-scroll";


const FooterSection = styled.div`
  background-color: #000000;
  width: 100%;
  height: 250px;
  position: relative;

  span {
    position: absolute;
    bottom: 4rem;
    color: #fff;
    cursor: pointer;
    transition: color 0.3s ease;
    font-size: 1.8rem;
    font-weight: 600;

    &:hover {
      color: #cccccc;
    }
  }
`;
function Footer() {
  return (
    <FooterSection>
      <div className="Container">
        <span>
          <ScrollLink
            to="projects"
            smooth={true}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            Stay tuned for More!!!
          </ScrollLink>
        </span>
      </div>
    </FooterSection>
  );
}

export default Footer;
